import lscache from "lscache";

import {resetAmplitude} from "@pg-mono/amplitude";
import {kmApiLink} from "@pg-mono/km-routes";
import {appendQueryString} from "@pg-mono/request";

import {
    APPLICATION_LOCAL_STORAGE_KEY,
    HOME_MATCH_PREFERENCES_MODAL_DISMISSED,
    PHONE_NUMBER_MODAL_DISMISSED,
    PHONE_VERIFICATION_MODAL_DISMISSED,
    PROFILE_PICTURE_AUTH_KIND
} from "@/features/km_app/constants/storage_keys";
import {trackAmplitudeLoggedOut} from "@/features/tracking/amplitude/track_amplitude_logged_out";
import {waitForAmplitudeFlush} from "@/features/tracking/amplitude/wait_for_amplitude_flush";
import {sessionCache} from "@/utils/session_cache";

interface ILogoutUserParams {
    next?: string;
    redirect?: (url: string) => void;
}

const removeLogoutLocalState = () => {
    lscache.remove(APPLICATION_LOCAL_STORAGE_KEY);
    lscache.remove(HOME_MATCH_PREFERENCES_MODAL_DISMISSED);
    lscache.remove(PHONE_NUMBER_MODAL_DISMISSED);
    lscache.remove(PHONE_VERIFICATION_MODAL_DISMISSED);
    lscache.remove(PROFILE_PICTURE_AUTH_KIND);
    sessionCache.remove(HOME_MATCH_PREFERENCES_MODAL_DISMISSED);
};

const defaultRedirect = (url: string) => {
    window.location.href = url;
};

export const logoutUser = async ({next, redirect = defaultRedirect}: ILogoutUserParams) => {
    const logoutUrl = appendQueryString(kmApiLink.user.logout(), {next});

    removeLogoutLocalState();
    trackAmplitudeLoggedOut({logoutPlacement: "km"});

    try {
        await waitForAmplitudeFlush();
    } finally {
        resetAmplitude();
        redirect(logoutUrl);
    }
};
import lscache from "lscache";

import {resetAmplitude} from "@pg-mono/amplitude";
import {kmApiLink} from "@pg-mono/km-routes";
import {appendQueryString} from "@pg-mono/request";

import {
    APPLICATION_LOCAL_STORAGE_KEY,
    HOME_MATCH_PREFERENCES_MODAL_DISMISSED,
    PHONE_NUMBER_MODAL_DISMISSED,
    PHONE_VERIFICATION_MODAL_DISMISSED,
    PROFILE_PICTURE_AUTH_KIND
} from "@/features/km_app/constants/storage_keys";
import {trackAmplitudeLoggedOut} from "@/features/tracking/amplitude/track_amplitude_logged_out";
import {waitForAmplitudeFlush} from "@/features/tracking/amplitude/wait_for_amplitude_flush";
import {sessionCache} from "@/utils/session_cache";

interface ILogoutUserParams {
    next?: string;
    redirect?: (url: string) => void;
}

const removeLogoutLocalState = () => {
    lscache.remove(APPLICATION_LOCAL_STORAGE_KEY);
    lscache.remove(HOME_MATCH_PREFERENCES_MODAL_DISMISSED);
    lscache.remove(PHONE_NUMBER_MODAL_DISMISSED);
    lscache.remove(PHONE_VERIFICATION_MODAL_DISMISSED);
    lscache.remove(PROFILE_PICTURE_AUTH_KIND);
    sessionCache.remove(HOME_MATCH_PREFERENCES_MODAL_DISMISSED);
};

const defaultRedirect = (url: string) => {
    window.location.href = url;
};

export const logoutUser = async ({next, redirect = defaultRedirect}: ILogoutUserParams) => {
    const logoutUrl = appendQueryString(kmApiLink.user.logout(), {next});

    removeLogoutLocalState();
    trackAmplitudeLoggedOut({logoutPlacement: "km"});

    try {
        await waitForAmplitudeFlush();
    } finally {
        resetAmplitude();
        redirect(logoutUrl);
    }
};
